export const timeRegex = /^((0[0-9])|(1[0-9])|(2[0-4])):[0-5][0-9]$/

export const colorRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/

export const dateRegex =
  /^(([1-2][0-9])|(0[1-9])|(3[0-1]))\.((1[0-2])|(0[1-9]))\.[0-9]{4}$/
